import { Button, Form, Input, Select, Upload } from "antd";
import FormItem from "antd/es/form/FormItem";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Option } from "antd/es/mentions";
import { UploadOutlined } from "@ant-design/icons";
import apiClient from "../../../utils/apiClient";
import useToast from "../../../hooks/userToast";

EditTemplate.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  fetchData: PropTypes.func.isRequired,
  handleOk: PropTypes.func.isRequired,
  modality: PropTypes.string,
};

const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  headers: {
    authorization: "authorization-text",
  },
  accept: ".doc,.docx", // Accept only Word files
};

function EditTemplate({ id, name, modality, fetchData, handleOk }) {
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({
    name: "",
    modality: modality,
    initialValues: id,
  });

  const { toastError, toastSuccess } = useToast();

  const handleEdit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("modality", values.modality);
      // console.log("values.pdf", values.pdf);
      values.pdf &&
        formData.append("template-pdf", values.pdf.file.originFileObj);

      await apiClient.patch(`template/${id}`, formData);
      toastSuccess("Updated Successfully!");
      fetchData();
      handleOk();
      form.resetFields();
    } catch (err) {
      console.error(err);
      toastError(err.message);
    }
  };

  useEffect(() => {
    if (id) {
      setInitialValues({ name, modality });
      form.setFieldsValue({ name, modality });
    }
  }, [id, name, modality]);

  //   useEffect(() => {
  //     if (hasSubmittedRef.current) {
  //       toastSuccess("Updated Successfully!");
  //       fetchData(); // Ensure fetchData is called to get the latest data
  //       handleOk();
  //       form.resetFields();
  //       hasSubmittedRef.current = false; // Reset submission status
  //     }
  //   }, [fetchData, handleOk, form, toastSuccess]);

  return (
    <>
      <Form onFinish={handleEdit} form={form} initialValues={initialValues}>
        <FormItem
          name="name"
          label="Name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input />
        </FormItem>

        <FormItem
          name="modality"
          label="Modality"
          rules={[{ required: true, message: "Modality is required" }]}
        >
          <Select defaultValue={initialValues.modality}>
            <Option value="CT">CT</Option>
            <Option value="MRI">MRI</Option>
            <Option value="X-RAY">X-RAY</Option>
          </Select>
        </FormItem>
        <FormItem name="pdf" label="Template File">
          <Upload {...props} maxCount={1}>
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </FormItem>

        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form>
    </>
  );
}

export default EditTemplate;
